import {Component, OnDestroy, OnInit} from "@angular/core";
import {UtilsService} from "../../../../core/utils/utils.service";
import {GestionGefService} from "../../../../core/services/gef/gestion-gef.service";
import {Subscription} from "rxjs";
import {GefAuditDto} from "../../../../core/dtos/gef/gef-audit-dto";
import {MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {ButtonThemeEnum} from '../../button/button-theme-enum';

@Component({
    selector: 'yo-dialog-gef-audit',
    templateUrl: './dialog-gef-audit.component.html',
    styleUrls: ['./dialog-gef-audit.component.scss'],
    standalone: false
})
export class DialogGefAuditComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  subGefAudit: Subscription;
  displayDialog = false;
  displayDialogDescription = false;
  selectedDescription: any;

  gefAuditList: GefAuditDto[];

  constructor(public utils: UtilsService,
              public gestionGefSvc: GestionGefService,
              public toastSvc: ToastService) {
  }

  ngOnInit() {
    this.initData();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subGefAudit);
  }

  initData = () => {
    this.subGefAudit = this.gestionGefSvc.displayGefAudit$.subscribe(response => {
      this.displayDialog = true;
      this.gefAuditList = response;
    });
  };

  closeDialog = () => {
    this.gefAuditList = [];
    this.displayDialog = false;
  };

  getScrollPanelStyle = () => {
    if (window.innerHeight <= 768) {
      return {width: '100%', height: '540px'};
    } else if (window.innerHeight <= 1024) {
      return {width: '100%', height: '704px'};
    } else {
      return {width: '100%', height: '740px'};
    }
  };

  updateValidationRequiredToFalse = (gefAudit: GefAuditDto) => {
    gefAudit.validationRequired = false;
    gefAudit.lastSynchro = this.utils.transformStringToDate(gefAudit.lastSynchro)
    this.gestionGefSvc.updateGefAudit(gefAudit).subscribe(response => {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, 'La validation a été effectuée avec succès');
    });
  }

  openDescriptionDialog(log: string) {
    this.selectedDescription = Object.entries(JSON.parse(log)).map(([key, value]) => ({key, value}));
    this.displayDialogDescription = true;
  }

  closeDescriptionDialog() {
    this.displayDialogDescription = false;
  }


}
